/**
 * Middleware for handling server/client relationships
 */
import { REDIRECT, REMOVE_COOKIE, SET_COOKIE } from 'constants/reduxActions';

import { removeCookie, setCookie } from 'helpers';

export const computeBaseUrl = () => {
  const { location: { protocol, host } } = window;
  return `${protocol}//${host}`;
};

export const browserMetadataMiddlewareFactory = history => {
  const baseUrl = computeBaseUrl();
  return () => next => action => {
    const { type, location, cookie } = action;
    switch (type) {
      case REDIRECT:
      {
        const interpolatedLocation = location.replace('{{applicationBaseUrl}}', baseUrl);
        /^http/.test(interpolatedLocation)
          ? window.location.replace(interpolatedLocation)
          : history.smartReplacePreserveAppRoot(interpolatedLocation); // when redirecting across stack boundaries we want to force refresh if the page isn't client routed.

        break;
      }
      case SET_COOKIE:
      {
        setCookie(cookie.name, cookie.value, { 'encode': cookie.options.encode || (f => f), 'path': '/', 'domain': cookie.options.domain, 'expires': cookie.options.expires });
        break;
      }
      case REMOVE_COOKIE:
      {
        removeCookie(cookie.name, cookie.domain);
        break;
      }

      default:
        break;
    }

    return next(action);
  };
};
